<section [ngSwitch]="listType" class="priority-list-container" [ngClass]="{'not-editable':!edit || !isListDraggable(),'no-counter':!counter}">
  <ng-container *ngIf="!hideTitles && (( listModel && listModel.length>0 ) || (showTitlesIfEmpty && listModel && listModel.length == 0)) ">
    <section  class="list-titles" *ngIf ="fields?.length>0" [ngClass]="{'titles-read-only-mode': disabled, 'titles-edit-mode': !disabled}">
      <span *ngIf="counter" class="counter-title">#</span>
      <ng-container *ngIf="!formVertical">
        <span *ngFor="let field of fields" [class.requiredField]="field?.required">{{field.label | translate}}</span>
      </ng-container>
      <span *ngIf="hasInlineAction()" class="actions-title"></span>
      <span *ngIf="hasInlineAction()" class="actions-title"></span>
      <span *ngIf="hasInlineAction()" class="actions-title"></span>
    </section>
  </ng-container>
  <ng-container *ngIf="prioritizeAvailable && edit; else List">
    <ng-container *ngTemplateOutlet="DraggableList"></ng-container>
  </ng-container>
  <div *ngSwitchCase="'manual-add-list'"  class="priority-item" [ngClass]="{'active': manualIsActive}" (click)="addItemEmit()">
    <section class="manual list-item-section">
      <ng-content select="[add-button]"></ng-content>
    </section>
  </div>
</section>

<ng-template #DraggableList>
  <ol class="priority-list draggable"
      [ngClass]="{'Auto_Priority_List_Editable':edit,'Auto_Priority_List_Reviewer':!edit}"
      [dragula]="prioritizeAvailable ? listName : null" [dragulaModel]="listModel" *ngIf="listModel">
    <ng-container *ngTemplateOutlet="IterateRows"></ng-container>
  </ol>

  <div class="empty-message-display" *ngIf="listModel?.length === 0 || !listModel">{{_emptyMessageDisplay | translate}}</div>
</ng-template>

<ng-template #List>
  <ol class="priority-list"
      [ngClass]="{'Auto_Priority_List_Editable':edit,'Auto_Priority_List_Reviewer':!edit}">
    <ng-container *ngTemplateOutlet="IterateRows"></ng-container>
  </ol>

  <div class="empty-message-display" *ngIf="listModel?.length === 0 || !listModel">{{_emptyMessageDisplay | translate}}</div>
</ng-template>

<ng-template #IterateRows>
  <li class="priority-item Auto_List_Item {{listName}}" *ngFor ="let item of listModel;index as i; trackBy:trackByFactory()">
    <ng-container [ngSwitch]="listRowType">
      <ng-container *ngSwitchCase="'content'" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit:{data:item,index:i}}"></ng-container>
      <gen-list-item *ngSwitchDefault class="list-item-section"
                     [ngClass]="getCssClass(item?.id)"
                     [fields]="fields"
                     [prioritizeAvailable]="isListDraggable()"
                     [item]="item"
                     (click)="onClick(i)"
                     (deleteActionEmit)="deleteEmit(item)"
      ></gen-list-item>
    </ng-container>
  </li>
</ng-template>

<ng-template #RowItem>
  <ng-content select="[list-item]"></ng-content>
</ng-template>
